// services/api.js
import axios from 'axios';

// Получаем базовый URL из переменных окружения
// REACT_APP_API_BASE_URL должен содержать полный путь, включая /api/v1
const getApiBaseURL = () => {
  
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  // Fallback на значения по умолчанию
  // В development используем HTTPS на порту 7174 (из launchSettings.json профиль "https")
  // Если бэкенд запущен на HTTP профиле, используйте http://localhost:5243/api/v1
  return process.env.NODE_ENV === 'production' 
    ? 'https://api.korzina.devzuckerigprod.ru/api/v1' 
    : 'https://localhost:7174/api/v1'; // HTTPS для development (порт 7174)
};

// Создаем и настраиваем экземпляр axios с правильным базовым URL
const api = axios.create({
  baseURL: getApiBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  }
});

// Добавляем интерцептор для добавления токена в заголовок и отключения кэша
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Для всех запросов отключаем кэширование
    config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
    
    // Удаляем заголовки, которые могут вызвать 304
    delete config.headers['If-None-Match'];
    delete config.headers['If-Modified-Since'];
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Добавляем интерцептор для обработки ошибок и обновления токена
api.interceptors.response.use(
  (response) => {
    // Если получили 304, это странно для API запросов - перезапрашиваем без кэша
    if (response.status === 304) {
      console.warn('Получен 304 статус для API запроса, повторяем запрос без кэша');
      // Повторяем запрос с заголовками, отключающими кэш
      const newConfig = {
        ...response.config,
        headers: {
          ...response.config.headers,
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      };
      delete newConfig.headers['If-None-Match'];
      delete newConfig.headers['If-Modified-Since'];
      return api.request(newConfig);
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Если ошибка 401 (неавторизован) и запрос не на обновление токена
    if (error.response?.status === 401 && !originalRequest._retry && 
        !originalRequest.url.includes('auth/refresh-token')) {
      originalRequest._retry = true;
      
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          // Если нет refresh токена, выходим из системы
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login';
          return Promise.reject(error);
        }
        
        // Пытаемся обновить токен
        // Важно: Используем axios напрямую, а не api, чтобы избежать цикличных вызовов интерцептора
        const refreshUrl = `${getApiBaseURL()}/auth/refresh-token`;
        const response = await axios.post(refreshUrl, { 
          refreshToken: refreshToken 
        });
        
        if (response.data && response.data.accessToken) { // Проверяем правильное имя поля
          localStorage.setItem('accessToken', response.data.accessToken);
          localStorage.setItem('refreshToken', response.data.refreshToken);
          
          // Обновляем заголовок в оригинальном запросе и повторяем его
          originalRequest.headers['Authorization'] = `Bearer ${response.data.accessToken}`;
          return axios(originalRequest);
        } else {
          // Если в ответе нет нужных полей, выходим из системы
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          window.location.href = '/login';
          return Promise.reject(error);
        }
      } catch (refreshError) {
        console.error('Ошибка при обновлении токена:', refreshError);
        // Если не удалось обновить токен, выходим из системы
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }
    
    // Добавим полезную информацию об ошибке в консоль
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);


export default api;